import BaseModel from '../core/BaseModel'
//import gql from 'graphql-tag'
export default class UnitHasKindTypeModel extends BaseModel {

    constructor() {
        super({
                name: "unit_has_kind_type",
                tableName: 'unit_has_kind_type',
                label: "Chủng loại",
            },
            {
                stt: {
                    name: "stt",
                    label: "STT",
                    type: "Computed",
                    computed: (data, index) => {
                        data.stt = index + 1;
                    },
                    // display: { list: true, add: false, edit: false }
                },
                id: {
                    name: "id",
                    display: false
                },
                unit_id: { 
                    name: 'unit_id',
                    display: false
                },
                kind_type_id: { 
                    name: 'kind_type_id',
                    display: false
                }

            },
            )
    }

}